import { EventListeners, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'

Locale.getInstance().registerKeySet('fr', 'lvcReportProblemButton', {
  text: 'Signaler un problème',
})
Locale.getInstance().registerKeySet('en', 'lvcReportProblemButton', {
  text: 'Report a problem',
})

export class LvcReportProblemButton extends MinzeElement {
  handleClick = () => {
    const element = MainModule.getInstance().getAuth().isLoggedIn()
      ? 'lvc-report-problem-popup'
      : 'lvc-not-logged-in-popup'
    MainModule.getInstance().injectIntoDOM(element)
  }

  html = () => `
    <button id="report-problem-button">
      <lvc-flag-icon></lvc-flag-icon>
      <div>${Locale.getKey('lvcReportProblemButton.text')}<div>
    </button>
  `

  css = () => `
    button {
      cursor: pointer;
      background: none;
      background-color: transparent;
      border: none;
      border-radius: 8px;
      padding: 0;
      font-family: inherit;
      font-size: 14px;
      font-weight: 500;
      color: #1E007D;
      display: flex;
      align-items: center;
      gap: 3px;
      transition: all ease 0.3s;
    }
    button:hover {
      transform: scale(1.025) translateY(-2px);
    }
  `
  eventListeners: EventListeners = [['#report-problem-button', 'click', this.handleClick]]
}
